import type { StoryImportRequiredResolution } from "@/features/story-import/story-import.types";

export function isImportReviewResolved(requiredResolution: StoryImportRequiredResolution | null | undefined) {
  return Boolean(requiredResolution?.isProjectUnlocked);
}

export function requiresImportReview(requiredResolution: StoryImportRequiredResolution | null | undefined) {
  return !isImportReviewResolved(requiredResolution);
}

export function shouldBlockProjectNavigationForImportReview() {
  return false;
}
